import './SubcategoryTabs.scss';
import Paragraph from 'components/TextComps/Paragraph';
import { useTranslation } from 'react-i18next';
import { Tab, Tabs } from '@trackman/web-shared-components';
import { ParameterSubcategoryView } from 'types/trackmanParameters';

type SubcategoryTabsProps = {
  subcategories: ParameterSubcategoryView[];
  selectedSubcategoryId: string | undefined;
  onSubcategorySelected: (subcategoryId: string) => void;
};

export const SubcategoryTabs = ({ subcategories, selectedSubcategoryId, onSubcategorySelected }: SubcategoryTabsProps) => {
  const { t } = useTranslation();

  const selectedSubcategoryIndex = Math.max(
    subcategories.findIndex((subcategory) => subcategory.id === selectedSubcategoryId),
    0
  );

  return (
    <div className='categories-container'>
      <Paragraph>
        <>{t('Categories', { ns: 'trackmanParameters' })}</>
      </Paragraph>
      <Tabs className='categories-list' value={selectedSubcategoryIndex}>
        {subcategories.map((subcategory) => (
          <Tab label={subcategory.title} key={subcategory.id} onClick={() => onSubcategorySelected(subcategory.id)} />
        ))}
      </Tabs>
    </div>
  );
};

export default SubcategoryTabs;
